import axios from 'axios';

axios.defaults.baseURL = "https://auth.ghelp.in/";



const getPortalDetails = (portalId) =>{
    return new Promise((resolve, reject)=>{
        axios.post("/portal/verify",{portalId:portalId}).then(res=>{
            if(res.data.error){
                reject(res.data.error)
            } else {
                localStorage.setItem("portalId",portalId);
                localStorage.setItem("portalUrl",res.data.data.url);
                localStorage.setItem("portalTitle",res.data.data.title);
                sessionStorage.clear();
                resolve(res.data)
            }
        }).catch(error=>{   
            reject(error) 
        })
    });
}





const landingServices = {
    getPortalDetails
}
export default landingServices;